import { classNamePrefix } from '../globals';
import { TConfig } from '../types';
import { renderButton } from './button';
import { renderDescription } from './description';
import { renderImage } from './image';
import { renderLink } from './link';
import { renderListButton } from './listButton';
import { renderModal } from './modal';
import { renderTitle } from './title';

export function renderHome (
    config: TConfig,
    delineAllChoices: () => void,
    acceptAllChoices: () => void,
    configureCallback: () => void
) {
    const className = classNamePrefix + '-home';
    const titleId = className + '-title';
    const descriptionId = className + '-description';

    const modalElement = renderModal(titleId, descriptionId);

    const homeElement = document.createElement('div');
    homeElement.classList.add(className);

    modalElement.appendChild(homeElement);

    const { privacyPolicy } = config.translations[config.language];
    const { title, description, accept, configure, decline } = config.translations[config.language].home;

    // Title
    const titleElement = renderTitle(title, 2, titleId);
    homeElement.appendChild(titleElement);

    // Image
    if (config.images?.home?.source) {
        const { source, alternative, width, height, alignment } = config.images.home;

        const imageElement = renderImage(source, alternative, width, height, alignment, className + '__image');
        homeElement.appendChild(imageElement);
    }

    // Description
    const descriptionElement = renderDescription(description, descriptionId);
    homeElement.appendChild(descriptionElement);

    // Link
    const linkElement = renderLink(privacyPolicy.url, privacyPolicy.label, '_self', `${className}__link`);
    homeElement.appendChild(linkElement);

    // Decline button
    const declineButtonElement = renderButton(decline, () => delineAllChoices(), `${className}__button-decline`);

    // Accept button
    const acceptButtonElement = renderButton(accept, () => acceptAllChoices(), `${className}__button-accept`);

    // Configure button
    const configureButtonElement = renderButton(configure, configureCallback, `${className}__button-configure`);

    // Button list
    const buttonListElement = renderListButton([declineButtonElement, acceptButtonElement, configureButtonElement]);
    homeElement.appendChild(buttonListElement);

    return modalElement;
}